<!--
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-09-14 10:11:52
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2025-12-08 19:32:10
 * @FilePath: \xht\git\xht-web-business\src\views\Order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-09-14 10:11:52
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2025-11-12 19:10:18
 * @FilePath: \xht\git\xht-web-business\src\views\Order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div style="max-width:430px;margin:0 auto;background:#f7f8fa;min-height:100vh;padding-bottom:80px;">
    <div style="height:56px;display:flex;align-items:center;justify-content:space-between;background:#fff;border-bottom:1px solid #f2f2f2;">
      <span style="font-size:26px;padding:0 16px;cursor:pointer;" @click="$router.push('/home')">&#8592;</span>
      <span style="font-size:22px;font-weight:bold;">确认订单</span>
      <span style="width:40px;text-align:right;padding:0 16px;font-size:26px;color:#222;">&#8942;</span>
    </div>
    <div style="display:flex;align-items:center;padding:18px 16px 10px 16px;background:#fff;">
      <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=200&q=80" alt="停车场" style="width:90px;height:90px;border-radius:12px;object-fit:cover;margin-right:14px;">
      <div style="flex:1;">
        <div style="font-size:20px;font-weight:bold;margin-bottom:4px;">{{ parkingName || pkgName }}</div>
        <!-- <div style="color:#888;font-size:15px;margin-bottom:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">📍 {{ parkingAddress || '—' }}</div> -->
        <!-- <div style="color:#bbb;font-size:14px;">距离您2.5公里</div> -->
      </div>
    </div>
    <div style="background:#fff;margin:0 0 12px 0;padding:0 0 24px 0; margin-top:30px;">
      <div style="display:flex;align-items:center;justify-content:space-between;padding:0 16px 0 16px; margin-bottom:18px;">
        <div style="font-size:22px;font-weight:bold;">{{ pkgName }}</div>
        <div style="font-size:22px;color:#222;font-weight:bold;">{{ pkgPriceText }}</div>
      </div>
      <div style="padding:8px 16px 0 16px; margin-bottom:18px;">
        <span style="background:#e6f3ff;color:#3572e6;padding:2px 12px;border-radius:12px;font-size:15px;margin-right:8px;">无需审核</span>
        <span style="background:#e6ffe6;color:#09bb07;padding:2px 12px;border-radius:12px;font-size:15px;">快速通行</span>
      </div>
      <div style="background:#fff;padding:0 16px 0 16px; margin-bottom:18px;">
        <div style="font-size:17px;font-weight:500;margin-bottom:12px;">使用时间</div>
        <div style="display:flex;align-items:center;margin-bottom:12px;">
          <span style="font-size:18px;">📅 起始日期</span>
          <input
            type="date"
            :value="selectedStartDateInput"
            @input="onStartDateChange($event.target.value)"
            :min="minStartDate"
            style="margin-left:auto;font-size:17px;padding:6px 12px;border:1px solid #ddd;border-radius:8px;outline:none;"
          />
        </div>
        <div style="color:#222;font-size:22px;font-weight:bold;margin-bottom:18px;">有效期至{{ validEnd }}</div>
      </div>
      <div style="background:#fff;padding:0 16px 16px;margin-bottom:18px;">
        <div style="font-size:17px;font-weight:500;margin-bottom:12px;">绑定车牌 <span style="color:#999;font-size:14px;">（最多 {{ carCount }} 个）</span></div>
        <div
          v-for="(plate, idx) in plateInputs"
          :key="idx"
          style="margin-bottom:10px;"
        >
          <input
            :value="plate"
            @click="openPlateKeyboard(idx)"
            type="text"
            maxlength="10"
            placeholder="请输入车牌号，如 浙A12345"
            readonly
            style="width:100%;height:44px;border:1px solid #ddd;border-radius:10px;padding:0 12px;font-size:16px;text-transform:uppercase;cursor:pointer;"
          >
        </div>
      </div>
      <div style="background:#fff;padding:0 16px 0 16px;margin-bottom:18px;display:flex;justify-content:space-between;align-items:center;">
        <div style="flex:1;text-align:center;">
          <div style="color:#222;font-size:18px;font-weight:500;margin-bottom:10px;">购买数量</div>
          <div style="display:flex;align-items:center;justify-content:center;">
            <button @click="changeCount('buy',-1)" style="width:36px;height:36px;border-radius:50%;border:1.5px solid #ddd;background:#fff;font-size:28px;color:#888;">-</button>
            <span style="width:36px;display:inline-block;text-align:center;font-size:20px;">{{ buyCount }}</span>
            <button @click="changeCount('buy',1)" style="width:36px;height:36px;border-radius:50%;border:1.5px solid #ddd;background:#fff;font-size:28px;color:#3572e6;">+</button>
          </div>
        </div>
        <div style="flex:1;text-align:center;">
          <div style="color:#222;font-size:18px;font-weight:500;margin-bottom:10px;">绑定车牌数</div>
          <div style="display:flex;align-items:center;justify-content:center;">
            <button @click="changeCount('car',-1)" style="width:36px;height:36px;border-radius:50%;border:1.5px solid #ddd;background:#fff;font-size:28px;color:#888;">-</button>
            <span style="width:36px;display:inline-block;text-align:center;font-size:20px;">{{ carCount }}</span>
            <button @click="changeCount('car',1)" style="width:36px;height:36px;border-radius:50%;border:1.5px solid #ddd;background:#fff;font-size:28px;color:#3572e6;">+</button>
          </div>
        </div>
      </div>
      <div style="background:#fff;padding:0 16px 0 16px;margin-bottom:18px;display:flex;align-items:center;">
        <input type="checkbox" :checked="agreeChecked" @change="onAgreeToggle" style="width:20px;height:20px;margin-right:8px;">
        <span style="font-size:17px;">我已阅读并同意 <span @click="openAgreement" style="color:#3572e6;text-decoration:underline;cursor:pointer;">《锡慧停停车优惠套餐购买服务协议》</span></span>
      </div>
      <div style="background:#fff;padding:0 16px 16px;display:flex;align-items:center;justify-content:space-between;">
        <span style="font-size:22px;color:#222;font-weight:bold;">合计{{ totalText }}</span>
        <button class="buy-btn" @click="pay">立即支付</button>
      </div>
    </div>
    <!-- 车牌输入键盘 -->
    <PlateKeyboard
      :visible="plateKeyboardVisible"
      :value="currentPlateValue"
      :maxLength="8"
      @input="handlePlateKeyboardInput"
      @close="closePlateKeyboard"
    />

    <!-- 购买协议弹窗 -->
    <div v-if="agreementVisible" class="agreement-mask">
      <div class="agreement-dialog">
        <div class="agreement-title">锡慧停停车优惠套餐购买服务协议</div>
        <div class="agreement-body" ref="agreeScroller" @scroll="onAgreementScroll">
          <pre class="agreement-text">锡慧停停车优惠套餐购买服务协议
《锡慧停停车场优惠套餐购买服务协议》（以下亦称“本协议”） 由您和无锡市新吴智慧停车运营管理有限公司（以下简称“锡慧停”）进行缔结，对双方具有同等法律效力。锡慧停建议您仔细阅读本协议的全部内容，尤其是以加粗形式展示的，与您的权益（可能）存在重大关系的条款（包括相关约定锡慧停责任、您享有的权利、争议解决方式及司法管辖等条款），请您留意重点阅读。若您认为本协议中的加粗条款可能会导致您的部分或全部权利或利益受损，请您务必再次仔细阅读，在确保您已经理解、接受了加粗条款的前提下，继续购买锡慧停停车优惠套餐服务。

如果您不同意本协议的任一或全部条款内容，请不要以确认形式（包括不限于支付行为/接受赠与等）进行下一步操作。当您以确认形式进行下一步操作时，即表示您与锡慧停已达成协议关系，您自愿接受本协议并遵守本协议项下的全部约定。

一、服务说明

锡慧停停车优惠套餐是由锡慧停向您提供的专享停车包年/包月/包周优惠权益，购买开通后可在相应的锡慧停运营管理范围内的封闭式场库或路内停车道路停放对应绑定的车辆（封闭式场库仅有包年和包月优惠，路内停车道路有包月和包周优惠服务），且本权益仅小型车可享。

二、购买须知

1、本链接中购买的“锡慧停”停车优惠套餐仅限首次开通优惠套餐的用户购买，如已开通优惠套餐，则需返回“锡慧停”公众号子菜单“优惠套餐续租”中缴费；

2、您的优惠套餐服务的服务期限以您自行选择具体停车场库或路内停车道路并支付相应优惠套餐费用对应的服务期限为准，停车场库于购买后当日离场生效，路内停车道路于购买次日开通（路内停车实行的是不固定不预留，先到先得的使用方式）；

3、若用户套餐过期后超时停放，出场时需要在收费处补齐超时部分停车费（费率以停放停车场收费标准为准）；

4、锡慧停在此特别提醒您，您在购买锡慧停停车优惠套餐服务（包括续费服务）之前应仔细核对账号信息、购买的服务内容（各停车场库及各路内停车道路均互不通用）、价格、服务期限等信息；

5、停车优惠套餐是您所购买的对应停车场库包年/包月或路内停车道路包月/包周停放的优惠价格，而非预付款或者存款、定金、储蓄卡等性质，优惠套餐一经开通后不可退款（如因优惠套餐服务存在重大瑕疵导致您完全无法使用等锡慧停违约情形、本协议另有约定、法律法规要求必须退款的或经锡慧停判断后认为可以退款等除外）；

6、我公司收取的停车优惠套餐费用是停车场地占用费，不含车辆保管费，如发生停车车辆被别蹭的问题，请服务对象第一时间进行报警、报险，停车场如有监控录像的配合协助交警调查取证；

7、蓝牌卡车以及黄牌车如需包周不在本停车优惠套餐服务范围内，请另行拨打400-900-9290客服热线咨询锡慧停。

三、服务的中断和终止

1、本服务的中断或终止包括如下情况：

1.1 您主动提出要求的；

1.2 您存在或经锡慧停独立判断后认为您存在任何违反国家法律法规或监管政策、违反本协议或有损锡慧停及其关联公司的声誉、利益的行为的；

1.3 不可抗力（不可抗力是指：不能预见、不能避免且不能克服的客观情况，如台风、

洪水、地震等自然灾害；鉴于互联网之特殊性质，本协议所称不可抗力亦包括黑客攻击、电信部门技术调整导致之重大影响、因政府管制而造成之暂时关闭、病毒侵袭等影响互联网正常运行之情形）；

1.4 其他锡慧停无法抗拒的情况。

2、当发生前述终止的情况时，您与锡慧停均认可如下处理方式：

2.1 如您在锡慧停平台内有正在进行中的交易，锡慧停届时将视情况进行合理处理；

2.2 除法律法规另有规定或因锡慧停原因导致本协议中断、终止或解除外，锡慧停已收取的停车优惠套餐费用不予退还；

2.3 如因您违反本协议导致终止的，锡慧停有权视情况要求您承担相应的违约责任；

2.4 除法律法规另有规定或锡慧停另有说明外，锡慧停无需向您和第三人承担任何责任。

四、您的个人信息保护

锡慧停深知个人信息对您的重要性，因此锡慧停非常重视保护您的个人信息，亦将您的个人信息以高度审慎的义务对待和处理。在您使用锡慧停停车优惠套餐服务的过程中，锡慧停将采用相关技术措施及其他安全措施来保护您的个人信息。

五、其他

1、本协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。

2、如就本协议的签订、履行等发生任何争议的，双方应尽量友好协商解决；协商不成时，任何一方均可向被告住所地享有管辖权的人民法院提起诉讼。

3、如本协议因与中华人民共和国现行法律相抵触而导致部分无效的，不影响协议的其他部分的效力。</pre>
          <p style="margin:0;height:1px;"></p>
        </div>
        <div class="agreement-actions">
          <button class="btn cancel" @click="closeAgreement">取消</button>
          <button class="btn primary" :disabled="!canAgree" @click="confirmAgreement">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { createMonthlyCardOrder, cancelMonthlyCardOrder } from '@/api/monthlyCard'
import { updateBusinessWalletBalance } from '@/api/business'
import PlateKeyboard from '@/components/PlateKeyboard.vue'

export default {
  name: 'OrderPage',
  components: {
    PlateKeyboard
  },
  data () {
    return {
      buyCount: 1,
      carCount: 1,
      pkg: null,
      businessId: null,
      plateInputs: [''],
      plateColors: ['BLUE_WHITE_COLOR'], // 车牌颜色数组，与 plateInputs 对应
      agreementVisible: false,
      canAgree: false,
      agreeChecked: false,
      submitting: false,
      selectedStartDate: null, // 用户选择的起始日期
      plateKeyboardVisible: false, // 车牌键盘显示状态
      currentPlateIndex: 0, // 当前正在输入的车牌索引
      currentPlateValue: '' // 当前输入的车牌值
    }
  },
  watch: {
    carCount () {
      this.syncPlateInputs()
    },
    buyCount () {
      // 购买数量变化时，结束日期会自动重新计算
    }
  },
  computed: {
    ...mapGetters(['balance', 'giftedBalance']),
    pkgName () { return (this.pkg && this.pkg.name) || '月卡套餐' },
    parkingName () { return (this.pkg && this.pkg.parking && this.pkg.parking.name) || '' },
    parkingAddress () { return (this.pkg && this.pkg.parking && this.pkg.parking.address) || '' },
    unitPrice () {
      const p = this.pkg && this.pkg.price
      const n = Number(p)
      return isNaN(n) ? 299 : n
    },
    pkgPriceText () {
      const first = this.pkg?.raw || this.pkg
      if (!first) return `¥${this.unitPrice}/月`
      
      // 根据cardType确定单位
      let unit = '月'
      const cardType = first.cardType || first.productType || first.type
      if (cardType) {
        const typeStr = String(cardType).toUpperCase()
        if (typeStr.includes('DAY') || typeStr.includes('DAILY') || typeStr.includes('日')) {
          unit = '日'
        } else if (typeStr.includes('YEAR') || typeStr.includes('YEARLY') || typeStr.includes('年')) {
          unit = '年'
        } else if (typeStr.includes('MONTH') || typeStr.includes('MONTHLY') || typeStr.includes('月')) {
          unit = '月'
        }
      }
      
      // 获取validityDuration
      const validityDuration = first.validityDuration || first.validityMonths || first.validityDays || first.validityYears
      
      // 构建单位字符串，如："30日"、"1月"、"1年"
      const unitStr = validityDuration ? `${validityDuration}${unit}` : unit
      
      return `¥${this.unitPrice}/${unitStr}`
    },
    total () { return this.unitPrice * this.buyCount * this.carCount },
    totalText () { return `¥${this.total}` },
    // 获取套餐的时间单位（日/月/年）
    pkgTimeUnit () {
      const first = this.pkg?.raw || this.pkg
      if (!first) return '月'
      const cardType = first.cardType || first.productType || first.type
      if (cardType) {
        const typeStr = String(cardType).toUpperCase()
        if (typeStr.includes('DAY') || typeStr.includes('DAILY') || typeStr.includes('日')) {
          return '日'
        } else if (typeStr.includes('YEAR') || typeStr.includes('YEARLY') || typeStr.includes('年')) {
          return '年'
        } else if (typeStr.includes('MONTH') || typeStr.includes('MONTHLY') || typeStr.includes('月')) {
          return '月'
        }
      }
      return '月'
    },
    // 获取套餐的有效期数值
    pkgValidityDuration () {
      const first = this.pkg?.raw || this.pkg
      if (!first) return 1
      const duration = first.validityDuration || first.validityMonths || first.validityDays || first.validityYears
      return Number(duration) || 1
    },
    // 用户选择的起始日期对象
    selectedStartDateObj () {
      if (this.selectedStartDate) {
        return this.parseDateStrict(this.selectedStartDate)
      }
      // 默认使用今天作为起始日期
      return new Date()
    },
    // 计算结束日期对象（基于选择的起始日期、购买数量和时间单位）
    endDateObj () {
      const startDate = this.selectedStartDateObj
      if (!startDate) return null
      
      const unit = this.pkgTimeUnit
      const duration = this.pkgValidityDuration
      const totalDuration = duration * this.buyCount
      
      let endDate
      if (unit === '日') {
        // 按天计算（与平台侧一致，含首日）：起始日期 + (总天数 - 1)
        endDate = new Date(startDate)
        endDate.setDate(endDate.getDate() + totalDuration - 1)
      } else if (unit === '年') {
        // 按年计算：起始日期 + 总年数
        endDate = new Date(startDate)
        endDate.setFullYear(endDate.getFullYear() + totalDuration)
      } else {
        // 按月计算（与平台侧一致）：起始日期 + 总月数（若目标月无同日则自动取目标月最后一天）
        endDate = this.addMonthsAligned(startDate, totalDuration)
      }
      
      // 检查计算出的结束时间是否超过产品的下架时间（cardValidEndTime）
      const productInfo = this.pkg?.raw || this.pkg
      if (productInfo && productInfo.cardValidEndTime) {
        const productEndDate = new Date(productInfo.cardValidEndTime)
        productEndDate.setHours(0, 0, 0, 0)
        const calculatedEndDate = new Date(endDate)
        calculatedEndDate.setHours(0, 0, 0, 0)
        
        // 如果计算出的结束日期超过了产品的下架时间，则限制为产品的下架时间
        if (calculatedEndDate > productEndDate) {
          return productEndDate
        }
      }
      
      return endDate
    },
    validStart () {
      const startDate = this.selectedStartDateObj
      if (!startDate) return '—'
      return this.formatDate(startDate)
    },
    validEnd () {
      const endDate = this.endDateObj
      if (!endDate) return '—'
      return this.formatDate(endDate)
    },
    // 日期选择器的值（YYYY-MM-DD格式）
    selectedStartDateInput () {
      if (this.selectedStartDate) {
        return this.selectedStartDate
      }
      const defaultDate = this.selectedStartDateObj
      if (defaultDate) {
        return this.formatDateForInput(defaultDate)
      }
      return this.formatDateForInput(new Date())
    },
    // 最小起始日期（今天）
    minStartDate () {
      return this.formatDateForInput(new Date())
    },
    // 最大购买数量（基于产品的 productMaxQuantity）
    maxBuyCount () {
      const productInfo = this.pkg?.raw || this.pkg
      if (productInfo && productInfo.productMaxQuantity != null) {
        return Number(productInfo.productMaxQuantity) || Infinity
      }
      return Infinity
    },
    // 最大绑定车牌数（基于产品的 maxBindPlateNumbers）
    maxCarCount () {
      const productInfo = this.pkg?.raw || this.pkg
      if (productInfo && productInfo.maxBindPlateNumbers != null) {
        return Number(productInfo.maxBindPlateNumbers) || Infinity
      }
      return Infinity
    }
  },
  methods: {
    ...mapActions(['FetchMerchantBalance']),
    // 验证并调整购买数量
    validateAndAdjustBuyCount () {
      if (this.buyCount < 1) {
        this.buyCount = 1
      }
      const maxCount = this.maxBuyCount
      if (maxCount !== Infinity && this.buyCount > maxCount) {
        console.warn(`购买数量 ${this.buyCount} 超过产品最大可售数量 ${maxCount}，已自动调整为 ${maxCount}`)
        this.buyCount = maxCount
      }
    },
    // 验证并调整绑定车牌数
    validateAndAdjustCarCount () {
      if (this.carCount < 1) {
        this.carCount = 1
      }
      const maxCount = this.maxCarCount
      if (maxCount !== Infinity && this.carCount > maxCount) {
        console.warn(`绑定车牌数 ${this.carCount} 超过产品最大绑定车牌数 ${maxCount}，已自动调整为 ${maxCount}`)
        this.carCount = maxCount
      }
    },
    changeCount (t, d) {
      if (t === 'buy') {
        const newCount = this.buyCount + d
        // 限制最小值
        if (newCount < 1) {
          return
        }
        // 限制最大值（基于产品的 productMaxQuantity）
        if (newCount > this.maxBuyCount) {
          alert(`该产品最多可购买 ${this.maxBuyCount} 张`)
          return
        }
        
        // 如果是增加数量（d > 0），检查增加后是否会导致结束日期超过产品下架时间
        if (d > 0) {
          const productInfo = this.pkg?.raw || this.pkg
          if (productInfo && productInfo.cardValidEndTime) {
            const startDate = this.selectedStartDateObj
            if (startDate) {
              // 计算新数量下的实际结束日期（应用产品下架时间限制后的值）
              const newEndDateRaw = this.calculateEndDateByCount(startDate, newCount)
              if (newEndDateRaw) {
                const productEndDate = new Date(productInfo.cardValidEndTime)
                productEndDate.setHours(0, 0, 0, 0)
                const calculatedEndDate = new Date(newEndDateRaw)
                calculatedEndDate.setHours(0, 0, 0, 0)
                
                // 应用产品下架时间限制：如果计算出的结束日期超过产品下架时间，则限制为产品下架时间
                let actualEndDate = calculatedEndDate
                if (calculatedEndDate > productEndDate) {
                  actualEndDate = productEndDate
                }
                
                // 获取当前数量下的实际结束日期（应用产品下架时间限制后的值）
                const currentEndDateRaw = this.calculateEndDateByCount(startDate, this.buyCount)
                let currentActualEndDate = null
                if (currentEndDateRaw) {
                  const currentCalculated = new Date(currentEndDateRaw)
                  currentCalculated.setHours(0, 0, 0, 0)
                  if (currentCalculated > productEndDate) {
                    currentActualEndDate = productEndDate
                  } else {
                    currentActualEndDate = currentCalculated
                  }
                }
                
                // 如果增加数量后，实际结束日期已经达到产品下架时间，且与当前数量下的实际结束日期相同
                // 说明增加数量不会再改变有效期，则阻止增加并提示
                if (currentActualEndDate && actualEndDate.getTime() === currentActualEndDate.getTime() && actualEndDate.getTime() === productEndDate.getTime()) {
                  const productEndDateStr = this.formatDate(productEndDate)
                  alert(`月卡有效期最多至${productEndDateStr}，无法继续增加数量`)
                  return
                }
              }
            }
          }
        }
        
        this.buyCount = newCount
        
        // 检查结束日期是否超过产品下架时间
        this.checkEndDateLimit()
      } else {
        const newCarCount = this.carCount + d
        // 限制最小值
        if (newCarCount < 1) {
          return
        }
        // 限制最大值（基于产品的 maxBindPlateNumbers）
        if (newCarCount > this.maxCarCount) {
          alert(`该产品最多可绑定 ${this.maxCarCount} 个车牌`)
          return
        }
        this.carCount = newCarCount
        this.syncPlateInputs()
      }
    },
    // 根据指定的开始日期和数量计算结束日期
    calculateEndDateByCount (startDate, count) {
      if (!startDate) return null
      
      const unit = this.pkgTimeUnit
      const duration = this.pkgValidityDuration
      const totalDuration = duration * count
      
      let endDate
      if (unit === '日') {
        // 按天计算（与平台侧一致，含首日）：起始日期 + (总天数 - 1)
        endDate = new Date(startDate)
        endDate.setDate(endDate.getDate() + totalDuration - 1)
      } else if (unit === '年') {
        // 按年计算：起始日期 + 总年数
        endDate = new Date(startDate)
        endDate.setFullYear(endDate.getFullYear() + totalDuration)
      } else {
        // 按月计算（与平台侧一致）：起始日期 + 总月数（若目标月无同日则自动取目标月最后一天）
        endDate = this.addMonthsAligned(startDate, totalDuration)
      }
      
      return endDate
    },
    // 检查结束日期是否超过产品下架时间
    checkEndDateLimit () {
      const productInfo = this.pkg?.raw || this.pkg
      if (!productInfo || !productInfo.cardValidEndTime) {
        return
      }
      
      const endDate = this.endDateObj
      if (!endDate) {
        return
      }
      
      const productEndDate = new Date(productInfo.cardValidEndTime)
      productEndDate.setHours(0, 0, 0, 0)
      const calculatedEndDate = new Date(endDate)
      calculatedEndDate.setHours(0, 0, 0, 0)
      
      // 如果计算出的结束日期超过了产品的下架时间，给出提示
      if (calculatedEndDate > productEndDate) {
        console.warn(`计算出的结束日期 ${this.formatDate(calculatedEndDate)} 超过了产品下架时间 ${this.formatDate(productEndDate)}`)
        // 注意：这里只记录警告，不阻止用户操作，因为 endDateObj 会自动限制为产品下架时间
      }
    },
    async pay () {
      if (this.submitting) return
      if (!this.pkg) {
        alert('未找到套餐信息，请返回重试')
        return
      }
      if (!this.agreeChecked) {
        this.openAgreement()
        return
      }
      const businessId = this.resolveBusinessId()
      if (!businessId) {
        alert('未获取到商户信息，请返回首页重新进入')
        return
      }
      this.submitting = true
      let orderId = null
      try {
        // 获取最新的账户余额和赠送余额
        let latestBalance = this.balance
        let latestGiftedBalance = this.giftedBalance
        try {
          await this.FetchMerchantBalance()
          // FetchMerchantBalance 会同时更新 balance 和 giftedBalance
          // 等待 Vue 响应式更新后读取最新值
          await this.$nextTick()
          latestBalance = this.balance
          latestGiftedBalance = this.giftedBalance
        } catch (e) {
          console.warn('获取商户余额失败，将使用本地缓存余额', e)
        }

        const payableAmount = Number(this.total.toFixed(2))
        
        // 验证余额值的有效性：必须是有效的数字且大于等于0
        const isValidBalance = (val) => {
          return typeof val === 'number' && !isNaN(val) && val >= 0
        }
        
        const walletBalance = isValidBalance(latestBalance) ? latestBalance : null
        const giftedBalance = isValidBalance(latestGiftedBalance) ? latestGiftedBalance : null
        
        // 如果余额无效，阻止支付
        if (walletBalance === null || giftedBalance === null) {
          alert('无法获取有效的账户余额信息，请刷新页面后重试')
          this.submitting = false
          return
        }
        
        const totalAvailableBalance = walletBalance + giftedBalance

        // 检查总可用余额是否足够
        if (totalAvailableBalance < payableAmount) {
          alert(`账户余额不足，账户余额：¥${walletBalance.toFixed(2)}，赠送余额：¥${giftedBalance.toFixed(2)}，合计：¥${totalAvailableBalance.toFixed(2)}，请先充值后再购买`)
          this.submitting = false
          return
        }

        
        // 验证购买数量是否超过产品的最大可售数量
        const productInfo = this.pkg?.raw || this.pkg
        if (productInfo && productInfo.productMaxQuantity != null) {
          const maxQuantity = Number(productInfo.productMaxQuantity)
          if (this.buyCount > maxQuantity) {
            alert(`购买数量不能超过 ${maxQuantity} 张`)
            this.submitting = false
            return
          }
        }
        
        // 验证绑定车牌数是否超过产品的支持泊位数（如果产品信息中有该字段）
        if (productInfo && productInfo.bindBerthNumbers != null) {
          const maxBerths = Number(productInfo.bindBerthNumbers)
          if (this.carCount > maxBerths) {
            alert(`绑定车牌数（${this.carCount}）超过产品支持的最大泊位数（${maxBerths}），请调整`)
            this.submitting = false
            return
          }
        }
        
        // 验证绑定车牌数是否超过产品的最大绑定车牌数（如果产品信息中有该字段）
        if (productInfo && productInfo.maxBindPlateNumbers != null) {
          const maxPlateNumbers = Number(productInfo.maxBindPlateNumbers)
          if (this.carCount > maxPlateNumbers) {
            alert(`绑定车牌数（${this.carCount}）超过产品最大绑定车牌数（${maxPlateNumbers}），请调整`)
            this.submitting = false
            return
          }
        }
        
        // 验证开始日期不能早于今天
        const startDate = this.selectedStartDateObj
        if (startDate) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          const selectedDate = new Date(startDate)
          selectedDate.setHours(0, 0, 0, 0)
          if (selectedDate < today) {
            alert('开始日期不能早于今天，请重新选择')
            this.submitting = false
            return
          }
        } else {
          alert('请选择开始日期')
          this.submitting = false
          return
        }
        
        // 验证结束日期不能超过产品的下架时间
        const endDate = this.endDateObj
        if (endDate && productInfo && productInfo.cardValidEndTime) {
          const productEndDate = new Date(productInfo.cardValidEndTime)
          productEndDate.setHours(0, 0, 0, 0)
          const calculatedEndDate = new Date(endDate)
          calculatedEndDate.setHours(0, 0, 0, 0)
          
          if (calculatedEndDate > productEndDate) {
            alert(`结束日期不能超过产品下架时间（${this.formatDate(productEndDate)}），请调整购买数量或开始日期`)
            this.submitting = false
            return
          }
        }
        
        const payload = this.buildOrderPayload()
        if (!payload) {
          alert('订单数据异常，请稍后重试')
          return
        }
        const orderResp = await createMonthlyCardOrder(payload)
        orderId = orderResp?.data?.orderId || orderResp?.data?.orderID || orderResp?.orderId || orderResp?.orderID || null

        // 计算扣除金额分配：优先扣除赠送余额，赠送余额扣除至0，再开始扣除储值余额
        let deductFromWallet = 0
        let deductFromGifted = 0

        if (giftedBalance >= payableAmount) {
          // 赠送余额足够，全部从赠送余额扣除
          deductFromGifted = payableAmount
        } else {
          // 赠送余额不足，先扣除全部赠送余额，剩余部分从账户余额扣除
          deductFromGifted = giftedBalance
          deductFromWallet = payableAmount - giftedBalance
        }

        // 计算新的余额（确保不会出现负数）
        const newWalletBalance = Math.max(0, Number((walletBalance - deductFromWallet).toFixed(2)))
        const newGiftedBalance = Math.max(0, Number((giftedBalance - deductFromGifted).toFixed(2)))
        
        // 验证计算后的余额是否合理（不应该大于原始余额）
        if (newWalletBalance > walletBalance || newGiftedBalance > giftedBalance) {
          console.error('余额计算异常:', {
            walletBalance,
            newWalletBalance,
            giftedBalance,
            newGiftedBalance,
            deductFromWallet,
            deductFromGifted
          })
          alert('余额计算异常，请刷新页面后重试')
          this.submitting = false
          return
        }

        // 更新两个余额（只更新计算后的有效值，不会强制设置为0）
        await updateBusinessWalletBalance({
          businessId,
          walletBalance: newWalletBalance,
          giftedAmount: newGiftedBalance
        })

        try {
          await this.FetchMerchantBalance()
        } catch (e) {
          console.warn('支付成功后刷新余额失败', e)
        }
        alert('支付成功！')
        try { sessionStorage.removeItem('selected_package') } catch (e) { /* ignore */ }
        this.$router.replace('/home')
      } catch (err) {
        console.error('支付失败', err)
        if (orderId) {
          try {
            await cancelMonthlyCardOrder(orderId)
          } catch (cancelErr) {
            console.warn('扣款失败后取消订单异常', cancelErr)
          }
        }
        alert(err?.response?.data?.message || err?.message || '支付失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    },
    onAgreeToggle (e) {
      // 若尚未勾选，则拦截勾选并先打开协议；确认后才设置为已勾选
      if (!this.agreeChecked) {
        e.target.checked = false
        this.openAgreement()
      } else {
        // 已勾选 → 允许直接取消
        this.agreeChecked = false
      }
    },
    openAgreement () {
      this.agreementVisible = true
      this.canAgree = false
      this.$nextTick(() => {
        try { this.$refs.agreeScroller && (this.$refs.agreeScroller.scrollTop = 0) } catch (e) { /* ignore */ }
      })
    },
    closeAgreement () { this.agreementVisible = false },
    onAgreementScroll (e) {
      try {
        const el = e.target
        // 允许 4px 以内误差
        this.canAgree = el.scrollTop + el.clientHeight >= el.scrollHeight - 4
      } catch (err) { /* ignore */ }
    },
    confirmAgreement () { this.agreementVisible = false; this.agreeChecked = true },
    formatDate (v) {
      if (!v) return ''
      try {
        const d = v instanceof Date ? v : new Date(v)
        if (isNaN(d.getTime())) return String(v).slice(0, 10)
        const y = d.getFullYear()
        const m = (`0${d.getMonth()+1}`).slice(-2)
        const day = (`0${d.getDate()}`).slice(-2)
        return `${y}年${m}月${day}日`
      } catch (e) { return '' }
    },
    // 严格解析日期，避免时区偏移（仅取日期部分，按本地构造）
    parseDateStrict (v) {
      if (!v) return null
      if (v instanceof Date) return isNaN(v.getTime()) ? null : new Date(v.getFullYear(), v.getMonth(), v.getDate())
      try {
        const s = String(v)
        // 提取 YYYY-MM-DD
        const m = s.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/)
        if (m) {
          const y = Number(m[1]); const mo = Number(m[2]); const d = Number(m[3])
          return new Date(y, mo - 1, d)
        }
        // 兜底：Date 解析后再取本地年月日重建
        const tmp = new Date(s)
        if (isNaN(tmp.getTime())) return null
        return new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate())
      } catch (e) { return null }
    },
    daysInMonth (year, monthIndex) {
      return new Date(year, monthIndex + 1, 0).getDate()
    },
    isEndOfMonth (date) {
      return date.getDate() === this.daysInMonth(date.getFullYear(), date.getMonth())
    },
    // 计算月卡结束日期规则：
    // - 与平台侧一致：结束日期 = 起始日期 + N个月
    // - 若目标月没有该“同日”（如 1/31 + 1个月），则取目标月最后一天（如 2/28 或 2/29）
    addMonthsAligned (date, months) {
      try {
        const y = date.getFullYear()
        const m = date.getMonth()
        const d = date.getDate()
        const add = Number(months) || 0
        
        // 计算目标月份
        const targetMonthIndex = m + add
        const targetYear = y + Math.floor(targetMonthIndex / 12)
        const targetMonth = ((targetMonthIndex % 12) + 12) % 12
        const targetDays = this.daysInMonth(targetYear, targetMonth)
        
        let endDate
        if (d > targetDays) {
          // 如果目标月没有同一天（如1月31日 → 2月），则取目标月的最后一天
          endDate = new Date(targetYear, targetMonth, targetDays)
        } else {
          // 如果目标月有同一天，则取同一天
          endDate = new Date(targetYear, targetMonth, d)
        }
        
        return endDate
      } catch (e) { return date }
    },
    deriveStartDate () {
      // 优先使用用户选择的起始日期
      if (this.selectedStartDateObj) {
        return this.selectedStartDateObj
      }
      // 如果没有选择，使用默认值
      return this.getDefaultStartDate() || new Date()
    },
    // 获取默认起始日期（默认为今天）
    getDefaultStartDate () {
      // 默认使用今天作为起始日期
      return new Date()
    },
    // 将日期格式化为 YYYY-MM-DD 格式（用于 input[type="date"]）
    formatDateForInput (date) {
      if (!date) return ''
      const d = date instanceof Date ? date : new Date(date)
      if (isNaN(d.getTime())) return ''
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // 处理起始日期选择变化
    onStartDateChange (value) {
      if (value) {
        // 验证选择的日期不能早于今天
        const selectedDate = this.parseDateStrict(value)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        if (selectedDate && selectedDate < today) {
          alert('开始日期不能早于今天，请重新选择')
          // 重置为今天
          this.selectedStartDate = this.formatDateForInput(today)
          return
        }
        this.selectedStartDate = value
        
        // 检查结束日期是否超过产品下架时间
        this.checkEndDateLimit()
      } else {
        this.selectedStartDate = null
      }
    },
    deriveEndDate () {
      if (this.endDateObj) return this.endDateObj
      const start = this.deriveStartDate()
      return this.addMonthsAligned(start, this.buyCount)
    },
    toOffsetDateTimeString (date, endOfDay = false) {
      let dt = date instanceof Date ? new Date(date.getTime()) : new Date(date)
      if (isNaN(dt.getTime())) dt = new Date()
      if (endOfDay) dt.setHours(23, 59, 59, 999)
      else dt.setHours(0, 0, 0, 0)
      const offsetMinutes = -dt.getTimezoneOffset()
      const sign = offsetMinutes >= 0 ? '+' : '-'
      const absMinutes = Math.abs(offsetMinutes)
      const pad = (n, len = 2) => String(n).padStart(len, '0')
      const offsetHour = pad(Math.floor(absMinutes / 60))
      const offsetMinute = pad(absMinutes % 60)
      return `${pad(dt.getFullYear(), 4)}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}.${pad(dt.getMilliseconds(), 3)}${sign}${offsetHour}:${offsetMinute}`
    },
    buildOrderPayload () {
      const productId = this.pkg?.id || this.pkg?.productId || this.pkg?.raw?.productId || this.pkg?.raw?.id
      if (!productId) return null
      const quantity = Math.max(1, Number(this.buyCount) || 1)
      const totalAmount = Number((this.unitPrice * this.buyCount * this.carCount).toFixed(2))
      const startDate = this.deriveStartDate()
      const endDate = this.deriveEndDate()
      const plateNumbers = this.collectPlateNumbers()
      // 构建车牌颜色数组，确保与 plateNumbers 一一对应
      const plateColors = plateNumbers.map((plateNumber) => {
        // 从 plateInputs 中找到对应的索引
        const inputIndex = this.plateInputs.findIndex(p => String(p || '').toUpperCase().trim() === plateNumber)
        if (inputIndex !== -1 && this.plateColors[inputIndex]) {
          // 如果找到了对应的输入索引，使用对应的颜色
          return this.plateColors[inputIndex]
        }
        // 否则根据车牌号自动识别颜色
        return this.identifyPlateColor(plateNumber) || 'BLUE_WHITE_COLOR'
      })
      return {
        orderType: 'B',
        productId,
        productQuantity: quantity,
        totalAmount,
        actualAmount: totalAmount,
        paidAmount: totalAmount,
        purchaseChannel: 'MERCHANT_CLIENT',
        cardValidStartTime: this.toOffsetDateTimeString(startDate, false),
        cardValidEndTime: this.toOffsetDateTimeString(endDate, true),
        status: 'PAID',
        plateNumbers,
        plateColors
      }
    },
    syncPlateInputs () {
      const count = Math.max(1, Number(this.carCount) || 1)
      if (!Array.isArray(this.plateInputs)) this.plateInputs = []
      if (!Array.isArray(this.plateColors)) this.plateColors = []
      while (this.plateInputs.length < count) {
        this.plateInputs.push('')
        this.plateColors.push('BLUE_WHITE_COLOR') // 默认蓝底白字
      }
      if (this.plateInputs.length > count) {
        this.plateInputs.splice(count)
        this.plateColors.splice(count)
      }
    },
    onPlateInput (index, raw) {
      if (!Array.isArray(this.plateInputs)) this.plateInputs = []
      if (!Array.isArray(this.plateColors)) this.plateColors = []
      const normalized = (raw || '').toUpperCase().replace(/\s+/g, '')
      this.$set ? this.$set(this.plateInputs, index, normalized) : (this.plateInputs[index] = normalized)
      // 自动识别车牌颜色
      const identifiedColor = this.identifyPlateColor(normalized)
      this.$set ? this.$set(this.plateColors, index, identifiedColor) : (this.plateColors[index] = identifiedColor)
    },
    // 打开车牌输入键盘
    openPlateKeyboard (index) {
      this.currentPlateIndex = index
      this.currentPlateValue = this.plateInputs[index] || ''
      this.plateKeyboardVisible = true
    },
    // 关闭车牌输入键盘
    closePlateKeyboard () {
      this.plateKeyboardVisible = false
    },
    // 处理车牌键盘输入
    handlePlateKeyboardInput (value) {
      this.currentPlateValue = value
      this.onPlateInput(this.currentPlateIndex, value)
    },
    // 根据车牌号自动识别车牌颜色
    identifyPlateColor (plate) {
      if (!plate || plate.length < 6) {
        return 'BLUE_WHITE_COLOR' // 默认蓝底白字
      }
      const normalizedPlate = plate.replace(/\s+/g, '').toUpperCase()
      // 新能源车牌（常见 8 位）
      if (normalizedPlate.length === 8) {
        const prov = ['京', '沪', '粤', '浙', '苏', '鲁', '川', '渝', '津', '冀', '晋', '蒙', '辽', '吉', '黑', '皖', '闽', '赣', '豫', '鄂', '湘', '桂', '琼', '贵', '云', '藏', '陕', '甘', '青', '宁', '新']
        if (prov.some(p => normalizedPlate.startsWith(p))) {
          return 'GREEN_BLACK_COLOR' // 绿底黑字-小型新能源车
        }
      }
      // 普通车牌（常见 7 位）
      if (normalizedPlate.length === 7) {
        const prov = ['京', '沪', '粤', '浙', '苏', '鲁', '川', '渝', '津', '冀', '晋', '蒙', '辽', '吉', '黑', '皖', '闽', '赣', '豫', '鄂', '湘', '桂', '琼', '贵', '云', '藏', '陕', '甘', '青', '宁', '新']
        if (prov.some(p => normalizedPlate.startsWith(p))) {
          return 'BLUE_WHITE_COLOR' // 蓝底白字-小型燃油车
        }
      }
      // 特殊与港澳
      if (normalizedPlate.startsWith('WJ') || normalizedPlate.startsWith('军') || normalizedPlate.startsWith('海') || normalizedPlate.startsWith('空') || normalizedPlate.startsWith('北') || normalizedPlate.startsWith('南') || normalizedPlate.startsWith('东') || normalizedPlate.startsWith('西') || normalizedPlate.startsWith('中')) {
        return 'WHITE_BLACK_COLOR' // 白底黑字-警车等特种车辆
      }
      if (normalizedPlate.startsWith('粤Z') || normalizedPlate.includes('港') || normalizedPlate.includes('澳')) {
        return 'BLACK_WHITE_COLOR' // 黑底白字-使领馆及港澳车辆
      }
      // 默认蓝底白字
      return 'BLUE_WHITE_COLOR'
    },
    collectPlateNumbers () {
      if (!Array.isArray(this.plateInputs)) return []
      return this.plateInputs
        .map(p => String(p || '').toUpperCase().trim())
        .filter(Boolean)
        .slice(0, Math.max(1, Number(this.carCount) || 1))
    },
    resolveBusinessId () {
      if (this.businessId) return this.businessId
      const normalize = (val) => {
        if (!val) return null
        if (typeof val === 'string') return val
        if (typeof val === 'object' && val !== null) {
          if (val.businessId) return normalize(val.businessId)
          if (val.id) return normalize(val.id)
        }
        try { return String(val) } catch (e) { return null }
      }
      const fromPkg =
        (this.pkg && (this.pkg.businessId || this.pkg.businessID)) ||
        (this.pkg?.raw && (this.pkg.raw.businessId || this.pkg.raw.merchantId)) ||
        (Array.isArray(this.pkg?.raw?.merchantIds) && this.pkg.raw.merchantIds.length > 0 && this.pkg.raw.merchantIds[0])
      const normalizedPkgId = normalize(fromPkg)
      if (normalizedPkgId) {
        this.businessId = normalizedPkgId
        return this.businessId
      }
      try {
        const cached = localStorage.getItem('currentBusiness')
        if (cached) {
          const parsed = JSON.parse(cached)
          const id = normalize(parsed?.businessId || parsed?.id)
          if (id) {
            this.businessId = id
            return this.businessId
          }
        }
      } catch (e) { /* ignore */ }
      return null
    }
  },
  mounted () {
    try {
      const raw = sessionStorage.getItem('selected_package')
      if (raw) this.pkg = JSON.parse(raw)
    } catch (e) { /* ignore */ }
    this.resolveBusinessId()
    this.FetchMerchantBalance().catch(e => console.warn('初始化查询余额失败', e))
    this.syncPlateInputs()
    // 验证并调整购买数量（如果超过产品最大数量限制）
    this.$nextTick(() => {
      this.validateAndAdjustBuyCount()
      this.validateAndAdjustCarCount()
    })
  }
}
</script>

<style scoped>
.agreement-mask {
  position: fixed; inset: 0; background: rgba(0,0,0,.45); display: flex; align-items: center; justify-content: center; z-index: 9999;
}
.agreement-dialog {
  width: 86%; max-width: 420px; background: #fff; border-radius: 14px; box-shadow: 0 12px 30px rgba(0,0,0,.18); padding: 14px 14px 12px 14px;
}
.agreement-title { font-size: 18px; font-weight: 700; color: #222; margin-bottom: 10px; text-align: center; }
.agreement-body {
  max-height: 50vh; overflow: auto; padding: 8px 6px; border: 1px solid #eee; border-radius: 10px; background: #fafafa; color: #444; line-height: 1.6; font-size: 14px;
}
.agreement-text {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  font-family: inherit;
}
.agreement-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 12px; }
.agreement-actions .btn { min-width: 84px; height: 36px; border: none; border-radius: 10px; cursor: pointer; font-size: 14px; font-weight: 600; }
.agreement-actions .btn.cancel { background: #f4f4f4; color: #555; }
.agreement-actions .btn.primary { background: linear-gradient(90deg,#4ca1ff,#70e1f5); color: #fff; }
.agreement-actions .btn.primary:disabled { opacity: .5; cursor: not-allowed; }
.buy-btn {
  width: 180px;
  height: 48px;
  background: linear-gradient(90deg,#4ca1ff,#70e1f5);
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  border: none;
  border-radius: 16px;
  cursor: pointer;
  box-shadow: 0 2px 8px #4ca1ff33;
  transition: background 0.2s, transform 0.1s;
}

.buy-btn:active {
  background: #4ca1ff;
  transform: scale(0.98);
}
</style>
